import React from "react";
import Footer from "components/footer/Footer";
import Header from "components/header";

interface Props {
  showHeader?: boolean;
  showFooter?: boolean;
  backgroundColor?: string;
  path?: string;
}

export const MainLayout: React.FC<Props> = ({
  showHeader = false,
  showFooter = false,
  children,
}) => (
  <>
    {showHeader && <Header />}

    {children}

    {showFooter && <Footer />}
  </>
);


export class EmptyLayout extends React.Component<React.PropsWithChildren<any>> {
  state = {
    showTosNotice: false,
  };

  closeNotice = () => {
    // eslint-disable-next-line no-invalid-this
    this.setState({ showTosNotice: false });
  };

  render (): React.ReactNode {
    return (
      <div>
        <div role="main" className="bk-navy" style={{ minHeight: "100vh" }}>
          <div style={{ padding: 8 }}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}
